import APIconsume from 'Main/APIconsume'

const BASE_URL = '/api/dashboard/payment-vendors'
const TEST_URL = '/payment-vendor/test'
const BALANCE_URL = '/payment-vendor/balance'

class PaymentVendorsService {
  constructor () {
    this._apiConsume = new APIconsume()
  }

  async getAll () {
      const result = await this._apiConsume.getData(BASE_URL)
      return result?.data
  }

  async getById (id) {
      const result = await this._apiConsume.getData(`${BASE_URL}/${id}`)
      return result?.data
  }

  async unlock (id, password) {
      const result = await this._apiConsume.postData({ password }, `${BASE_URL}/${id}/unlock`)
      return result?.data
  }

  async create (payload) {
      const result = await this._apiConsume.postData(payload, BASE_URL)
      return result?.data
  }

  async update (id, payload, password) {
      const result = await this._apiConsume.putData({ ...payload, password }, `${BASE_URL}/${id}`)
      return result?.data
  }

  async remove (id) {
      const result = await this._apiConsume.deleteData(`${BASE_URL}/${id}`)
      return result?.data
  }

  async testConnection (id) {
      const result = await this._apiConsume.postData({ id }, TEST_URL)
      return result?.data
  }

  async checkBalance (id) {
      const result = await this._apiConsume.postData({ id }, BALANCE_URL)
      return result?.data
  }
}

export default PaymentVendorsService
